module.exports = __webpack_public_path__ + "static/media/curve-3-flipped.c8146729.svg";